module.exports = __webpack_public_path__ + "img/googleplay.07120e7.svg";